import Vue from 'vue'
import Router from 'vue-router'
// import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior (to, from, savedPosition) {
    if (to.hash !== "") { //ハッシュがある時はそこまで移動
      document.getElementById(to.hash.replace(/^#/, '')).scrollIntoView();
    } else if(savedPosition) {
      return savedPosition //戻る・進むのときには元々いた場所に戻る
    } else {
      return { x: 0, y: 0 } //そうでないときはトップへ
    }
  },
  routes: [
    {
      path: '/',
      name: 'Home',
      // component: Home
      // route level code-splitting
      // this generates a separate chunk (Home.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "Home" */ './views/Home.vue')
    },
    {
      path: '/about',
      name: 'About',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    },
    {
      path: '/person',
      name: 'Person',
      // route level code-splitting
      // this generates a separate chunk (people.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "people" */ './views/Person.vue')
    },
    {
      path: '/education',
      name: 'Education',
      // route level code-splitting
      // this generates a separate chunk (education.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "education" */ './views/Education.vue')
    },
    {
      path: '/welfare',
      name: 'Welfare',
      // route level code-splitting
      // this generates a separate chunk (welfare.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "welfare" */ './views/Welfare.vue')
    },
    {
      path: '/faq',
      name: 'Faq',
      // route level code-splitting
      // this generates a separate chunk (faq.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "welfare" */ './views/Faq.vue')
    },
    {
      path: '/schedule',
      name: 'Schedule',
      // route level code-splitting
      // this generates a separate chunk (schedule.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "welfare" */ './views/Schedule.vue')
    },
    {
      path: '/job',
      name: 'Job',
      // route level code-splitting
      // this generates a separate chunk (job.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "welfare" */ './views/Job.vue')
    },
    {
      path: '/job/grocery',
      name: 'Grocery',
      // route level code-splitting
      // this generates a separate chunk (grocery.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "welfare" */ './views/job/Grocery.vue')
    },
    {
      path: '/job/nousan',
      name: 'Nousan',
      // route level code-splitting
      // this generates a separate chunk (nousan.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "welfare" */ './views/job/Nousan.vue')
    },
    {
      path: '/job/chikusan',
      name: 'Chikusan',
      // route level code-splitting
      // this generates a separate chunk (nousan.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "welfare" */ './views/job/Chikusan.vue')
    },
    {
      path: '/job/nippai',
      name: 'Nippai',
      // route level code-splitting
      // this generates a separate chunk (nippai.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "welfare" */ './views/job/Nippai.vue')
    },
    {
      path: '/job/customer',
      name: 'Customer',
      // route level code-splitting
      // this generates a separate chunk (customer.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "welfare" */ './views/job/Customer.vue')
    },
    {
      path: '/job/souzai',
      name: 'Souzai',
      // route level code-splitting
      // this generates a separate chunk (souzai.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "welfare" */ './views/job/Souzai.vue')
    },
    {
      path: '/job/suisan',
      name: 'Suisan',
      // route level code-splitting
      // this generates a separate chunk (suisan.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "welfare" */ './views/job/Suisan.vue')
    },
    // {
    //   path: '*',
    //   name: '404',
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () => import(/* webpackChunkName: "404" */ './views/404.vue'),
    //   meta: {
    //     breadcrumb: 'Not Found 404',
    //   }
    // }
  ]
})
